import { HeroSection } from "@/components/landing/HeroSection";
import { QuizHookSection } from "@/components/landing/QuizHookSection";
import { InActionSection } from "@/components/landing/InActionSection";
import { HowItWorksSection } from "@/components/landing/HowItWorksSection";
import { CommunitySection } from "@/components/landing/CommunitySection";
import { NextEventSection } from "@/components/landing/NextEventSection";
import { SupportCTA } from "@/components/landing/SupportCTA";
import { ShareSection } from "@/components/landing/ShareSection";
import { FAQSection } from "@/components/landing/FAQSection";
import { fetchHeroStats } from "@/api/geography";
import { useQuizruns } from "@/hooks/useQuizruns";
import { useQuery } from "@tanstack/react-query";
import { collectRegistrationEvents } from "@/lib/registrationUtils";
import { useMemo, useEffect } from "react";
import type { HeroStats } from "@/types/domain";
import { statsKeys } from "@/api/queryKeys";

const Index = () => {
  useEffect(() => {
    document.title =
      "Quizrun — Run & Think | A 5K Race Where Quiz Answers Cut Your Time";
  }, []);
  const { data: heroStats } = useQuery({
    queryKey: statsKeys.hero,
    queryFn: fetchHeroStats,
    staleTime: 10 * 60 * 1000,
  });

  const { data: quizruns } = useQuizruns();

  const stats: HeroStats = {
    finishers: heroStats?.totalFinishers ?? 0,
    events: heroStats?.finishedEvents ?? 0,
    cities: heroStats?.totalCities ?? 0,
  };

  const registrationEvents = useMemo(() => {
    if (!quizruns) return [];
    return collectRegistrationEvents(quizruns);
  }, [quizruns]);

  return (
    <div className="overflow-hidden">
      <HeroSection stats={stats} />
      <QuizHookSection />
      <HowItWorksSection />
      <InActionSection />
      <NextEventSection registrationEvents={registrationEvents} />
      <CommunitySection />
      <ShareSection />
      <FAQSection />
      <SupportCTA />
    </div>
  );
};

export default Index;
